/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * ADL
 */
export type RequestSummaryADLEnum =
  (typeof RequestSummaryADLEnum)[keyof typeof RequestSummaryADLEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestSummaryADLEnum = {
  INDEPENDENT: 'INDEPENDENT',
  CARE_REQUIRED: 'CARE_REQUIRED',
  BEDRIDDEN: 'BEDRIDDEN',
  PARTIAL_ASSISTANCE: 'PARTIAL_ASSISTANCE',
  FULL_ASSISTANCE: 'FULL_ASSISTANCE',
  UNKNOWN: 'UNKNOWN',
} as const;
